import { Route, Routes, useLocation } from 'react-router-dom';
import { SignInScreen } from '../../components/SignInScreen';
import { LegacyPublicDrawingRedirect, PublicDrawingPage } from './PublicDrawingPage';
import { PublicReactionPage } from './PublicReactionPage';
import { BondGlossaryPage, BondTermPage } from './BondGlossaryPage';
import { PublicHome } from './PublicHome';
import { LegacyPublicMoleculeRedirect, PublicMoleculePage } from './PublicMoleculePage';
import { PublicAccessContext } from './publicAccess';

interface SignedOutAppProps {
  readonly signIn: (returnTo?: string) => void;
  readonly signUp: (returnTo?: string) => void;
  readonly signInError: string | null;
}

function SignInForThisPage({ signIn, signUp, signInError }: SignedOutAppProps) {
  const location = useLocation();
  const here = location.pathname + location.search;
  return <SignInScreen onSignIn={() => signIn(here)} onSignUp={() => signUp(here)} signInError={signInError} />;
}

/**
 * #885 (owner decision #632): what a signed-out visitor can reach -- the public catalog (home,
 * search, drawing pages, and molecule pages since ADR 0017 D10). Everything else, the workspace
 * included, still asks them to sign in, then returns them to where they were going.
 */
export function SignedOutApp({ signIn, signUp, signInError }: SignedOutAppProps) {
  return (
    <PublicAccessContext.Provider value={{ signedIn: false, signIn, signUp, signInError }}>
      <Routes>
        <Route path="/" element={<PublicHome />} />
        <Route path="/public" element={<PublicHome />} />
        <Route path="/i/:id" element={<PublicDrawingPage />} />
        {/* #1124 (ADR 0023): a public reaction. */}
        <Route path="/r/:id" element={<PublicReactionPage />} />
        {/* ADR 0023 D7 (#1126): the public bond glossary. */}
        <Route path="/bonds" element={<BondGlossaryPage />} />
        <Route path="/bonds/:slug" element={<BondTermPage />} />
        <Route path="/public/drawings/:id" element={<LegacyPublicDrawingRedirect />} />
        <Route path="/m/:id" element={<PublicMoleculePage />} />
        <Route path="/public/molecules/:id" element={<LegacyPublicMoleculeRedirect />} />
        <Route path="*" element={<SignInForThisPage signIn={signIn} signUp={signUp} signInError={signInError} />} />
      </Routes>
    </PublicAccessContext.Provider>
  );
}
